import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from '../../common/components/Dialog';
import { Button } from 'react-bootstrap';
import MarkAsPaidForm from './MarkAsPaidForm';
import RemoteSubmitButton from '../../common/components/formControls/RemoteSubmitButton';
import { withTranslation } from 'react-i18next';

class MarkAsPaidDialog extends Component {
    constructor(props) {
        super(props);
        this.handleIsInstalmentChange = this.handleIsInstalmentChange.bind(this);

        this.state = {
            isInstalment: null
        };
    }

    handleIsInstalmentChange(event, isInstalment) {
        this.setState({ isInstalment });
    }
    dialogConfig() {
        const { t, onCancel } = this.props;

        return {
            header: t('PaymentHistory_MarkAsPaid'),
            body: this.renderBody(),
            onHide: onCancel,
            footer: this.renderFooter()
        };
    }

    renderBody() {
        const { onConfirm, showPaymentOptions, enableManualInstalment } = this.props;
        return <MarkAsPaidForm onSubmit={onConfirm} showPaymentOptions={showPaymentOptions}
            enableManualInstalment={enableManualInstalment}
            isInstalment={this.state.isInstalment == 'true'}
            isInstalmentChange={this.handleIsInstalmentChange}
            initialValues={{
                paymentOption: showPaymentOptions ? 'Cash' : null,
                isInstalment: enableManualInstalment ? false : null
            }} />;
    }

    renderFooter() {
        const { onCancel, t } = this.props;

        const closeBtn = <Button key='close' onClick={onCancel}>{t('Common_Close')}</Button>;
        const confirmBtn = <RemoteSubmitButton key='save' style='primary' formName='markAsPaid' label={t('PaymentHistory_MarkAsPaid')} />;
        return [closeBtn, confirmBtn];
    }

    render() {
        const { show, block, unblock } = this.props;
        const dialogConfig = this.dialogConfig();
        return <Dialog config={dialogConfig} show={show} block={block} unblock={unblock} />;
    }
}

MarkAsPaidDialog.propTypes = {
    show: PropTypes.bool,
    showPaymentOptions: PropTypes.bool,
    enableManualInstalment: PropTypes.bool,
    block: PropTypes.oneOfType([
        PropTypes.instanceOf(RegExp),
        PropTypes.string,
        PropTypes.array,
        PropTypes.func
    ]),
    unblock: PropTypes.oneOfType([
        PropTypes.instanceOf(RegExp),
        PropTypes.string,
        PropTypes.array,
        PropTypes.func
    ]),
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired
};

export default withTranslation()(MarkAsPaidDialog);